import { ClientCreation } from '@Arti-zen/package-backoffice'
import SelectMui from 'components/forms/SelectMui'
import Info from 'components/Info'
import { InfoRedStyle, Row, ValidButton } from 'modules/product/ProductListTable.definitionFields'
import { useState } from 'react'

type TProps = {
  currentTitle: string
  correctClient: (corrections: Partial<ClientCreation>) => void
}

export default function TitleErrorTable({ currentTitle, correctClient }: TProps) {
  const [title, setTitle] = useState<ETitleClient>()

  const items = ['Mme', 'M.', 'M. et Mme'].map((civilite) => {
    return { value: civilite, label: civilite }
  })

  const updateTitle = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctClient({ title })
  }
  return (
    <>
      <Row style={{ paddingTop: 4 }}>
        <div style={{ position: 'relative' }}>
          <SelectMui items={items} value={title} onChange={(value) => setTitle(value)} fontSize={12} />
          <Info
            text={`La civilité renseignée est incorrecte : ${currentTitle}. Elle doit être choisie parmi : "Mme","M." ou "M. et Mme".`}
            style={{ ...InfoRedStyle, top: -4, right: -10 }}
            absolute
          />
        </div>
        <ValidButton onClick={updateTitle}>OK</ValidButton>
      </Row>
    </>
  )
}

export enum ETitleClient {
  'Madame' = 'Mme',
  'Monsieur' = 'M.',
  'Monsieur et madame' = 'M. et Mme',
}
